import { calculateVatComparation } from "@/helper/vat_helper";

export default {
  namespaced: true,
  getters: {
    getPersonalRegisterVat(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: true,
        purchasePriceHasExcludeVat: false,
        aIsRegister: true,
        bIsRegister: true,
        isPersonal: true,
      });
    },
    getPersonalNotRegisterVat(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: true,
        purchasePriceHasExcludeVat: false,
        aIsRegister: false,
        bIsRegister: true,
        isPersonal: true,
      });
    },
    getCorporateRegisterVat(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: true,
        purchasePriceHasExcludeVat: false,
        aIsRegister: true,
        bIsRegister: true,
        isPersonal: false,
      });
    },
    getCorporateNotRegisterVat(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: true,
        purchasePriceHasExcludeVat: false,
        aIsRegister: false,
        bIsRegister: true,
        isPersonal: false,
      });
    },
    getPersonalWithVatInfo(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: false,
        purchasePriceHasExcludeVat: false,
        aIsRegister: true,
        bIsRegister: true,
        isPersonal: true,
      });
    },
    getPersonalWithoutVatInfo(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: false,
        purchasePriceHasExcludeVat: true,
        aIsRegister: true,
        bIsRegister: false,
        isPersonal: true,
      });
    },
    getCorporateWithoutVatInfo(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: false,
        purchasePriceHasExcludeVat: true,
        aIsRegister: true,
        bIsRegister: false,
        isPersonal: false,
      });
    },
    getCorporateWithVatInfo(state, getters, rootState) {
      const taxInfo = rootState.taxInfo;
      const sellingPrice = taxInfo.income.onlineSelling;
      const purchasePrice = taxInfo.expense.cost;
      return calculateVatComparation({
        sellingPrice: sellingPrice * 12,
        purchasePrice: purchasePrice * 12,
        sellPriceHasExcludeVat: false,
        purchasePriceHasExcludeVat: false,
        aIsRegister: true,
        bIsRegister: true,
        isPersonal: false,
      });
    },
  },
};
